// Application Layer - Servicio de PWA
import { PWAServiceWorkerAdapter } from '../../infrastructure/pwa/PWAServiceWorkerAdapter';
import { PWAInstallAdapter } from '../../infrastructure/pwa/PWAInstallAdapter';

export class PWAService {
  constructor(
    private readonly serviceWorkerAdapter: PWAServiceWorkerAdapter,
    private readonly installAdapter: PWAInstallAdapter
  ) {}

  async initialize(): Promise<void> {
    await this.serviceWorkerAdapter.register();
  }

  async checkForUpdates(): Promise<boolean> {
    return await this.serviceWorkerAdapter.checkForUpdates();
  }

  canInstall(): boolean {
    return this.installAdapter.canInstall();
  }

  async install(): Promise<boolean> {
    return await this.installAdapter.promptInstall();
  }

  isInstalled(): boolean {
    return this.installAdapter.isInstalled();
  }

  async unregister(): Promise<boolean> {
    return await this.serviceWorkerAdapter.unregister();
  }
}
